<div class="tt-w-reviews-list">
  <tt-user-toolbar v-if="showUserToolbar"></tt-user-toolbar>
  <tt-reviews-list @openMediaModal="openMediaModal"></tt-reviews-list>
  <tt-related-reviews-list v-if="showRelatedList && !showSearchResults" @openMediaModal="openMediaModal"></tt-related-reviews-list>
</div>



// WEBPACK FOOTER //
// ./src/widgets/reviews-list/reviews-list-widget.html